import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';

export const savedRepliesTabStyles = StyleSheet.create({
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'flex-start',
		gap: 16,
		marginBottom: 16,
	},
	headerDescription: {
		margin: 0,
	},
	searchBar: {
		marginBottom: 16,
		maxWidth: 360,
	},
	editorHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		marginBottom: 6,
	},
	replyItem: {
		borderBottom: `1px solid ${THEME.colors.border.light}`,
		':last-child': {
			borderBottom: 'none',
		},
	},
	replyHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '12px 16px',
		cursor: 'pointer',
		':hover': {
			backgroundColor: THEME.colors.background.main,
		},
	},
	replyInfo: {
		display: 'flex',
		flexDirection: 'column' as const,
		gap: 2,
		flex: 1,
		minWidth: 0,
	},
	replyName: {
		fontSize: 14,
		fontWeight: 600,
		color: THEME.colors.text.main,
	},
	replyPreview: {
		fontSize: 13,
		color: THEME.colors.text.light,
		whiteSpace: 'nowrap' as const,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	replyActions: {
		marginLeft: 12,
		flexShrink: 0,
	},
});
